export default "__VITE_ASSET__DNZ$_wOT__"